import planService from 'src/services/plan'
import { action } from 'typesafe-actions'
import { PlanTypes } from '../types/planTypes'
import {
  getValidationErrorMessage,
  getErrorHelper,
} from 'src/utils/response-helpers'
export const getMyPlanAction = () => {
  return async (dispatch: any) => {
    dispatch(action(PlanTypes.GET_USER_PLANS_REQUEST))
    try {
      const response: any = await planService.getUserPlans()
      dispatch(action(PlanTypes.GET_USER_PLANS_CALL, response.data.data))
    } catch (error) {
      console.log(error)
    }
  }
}
export const getMyPlanByIdAction = (id: any) => {
  return async (dispatch: any) => {
    dispatch(action(PlanTypes.GET_USER_PLAN_BY_ID_REQUEST))
    try {
      const response: any = await planService.getPlanById(id)
      dispatch(action(PlanTypes.GET_USER_PLAN_BY_ID, response.data.data.plan))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
export const deletePlanAccountAction = ({ id, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response = await planService.deletePlan({ id })
      if (!response.data.data.successful) {
        onError(getValidationErrorMessage(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      dispatch(
        action(PlanTypes.DELETE_PLAN_REQUEST_SUCCESS, response.data.data)
      )
      Promise.all([dispatch(getMyPlanAction())])
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const createPlanAction = ({ planData, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    dispatch(action(PlanTypes.CREATE_PLAN_REQUEST))
    try {
      const response: any = await planService.createPlan(planData)
      if (!response.data.data.successful) {
        onError(getValidationErrorMessage(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
        dispatch(
          action(PlanTypes.CREATE_PLAN_REQUEST_SUCCESS, response.data.data)
        )
        dispatch(action(PlanTypes._CLEAR_PLAN_FORM))
      }
      Promise.all([dispatch(getMyPlanAction())])
    } catch (error) {
      onError(getValidationErrorMessage(error))
      getErrorHelper(error)
    }
  }
}
export const updatePlanAction = ({ plan, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await planService.updatePlan(plan)
      if (!response.data.data.successful) {
        onError(getValidationErrorMessage(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      Promise.all([dispatch(getMyPlanAction())])
    } catch (error) {
      onError(getValidationErrorMessage(error))
      getErrorHelper(error)
    }
  }
}
export const validatePlanNameAction = ({
  payload,
  onSuccess,
  onError,
}: any) => {
  const { planName } = payload
  return async (dispatch: any) => {
    try {
      const response: any = await planService.validatePlanName(planName)
      if (!response.data.data.successful) {
        onError?.(response.data.message)
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      console.log(response)
    } catch (error) {
      onError?.(getErrorHelper(error))
    }
  }
}

export const topUpPlanAction = ({ payload, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    dispatch(action(PlanTypes.TOP_UP_PLAN_REQUEST))

    try {
      const response: any = await planService.fundPlan(payload)
      if (!response.data.data.successful) {
        onError?.(response.data.message)
      } else {
        onSuccess?.(response.data.data)
        dispatch(
          action(
            PlanTypes.TOP_UP_PLAN_REQUEST_SUCCESS,
            response.data.data.payment
          )
        )
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
